import { computed, ref } from 'vue'

import { defineStore } from 'pinia'

export const useSideMenuStore = defineStore('sideMenu', () => {
  // State
  const sidebarActiveMenuIndex = ref(null)
  const sidebarActive = ref(
    localStorage.getItem('sidebarOpened') ? Boolean(Number(localStorage.getItem('sidebarOpened'))) : true
  )
  const sidebarArrowItem = ref(false)

  // Getters
  const getSidebarArrowItem = computed(() => sidebarArrowItem.value)
  const getSidebarActiveMenuIndex = computed(() => sidebarActiveMenuIndex.value)
  const getSidebarActive = computed(() => sidebarActive.value)

  // Actions
  const setActiveMenuIndex = index => {
    sidebarActiveMenuIndex.value = index
  }

  const setSidebarCollapseState = value => {
    sidebarActive.value = value
  }

  const setSidebarActive = value => {
    sidebarArrowItem.value = value
  }

  const clearActiveIndexes = () => {
    sidebarActiveMenuIndex.value = null
  }

  return {
    sidebarActiveMenuIndex,
    sidebarActive,
    sidebarArrowItem,
    getSidebarArrowItem,
    getSidebarActiveMenuIndex,
    getSidebarActive,
    setActiveMenuIndex,
    setSidebarCollapseState,
    setSidebarActive,
    clearActiveIndexes
  }
})
